module.exports = __webpack_public_path__ + "img/hopways.132c844f.jpg";